let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("kOzld")).then(() => parcelRequire('3mpWH'));